module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vpelv1-594a841ca91efcf87b4b0d72837f2af0.jpg";